export const RETRY_FETCH = 'usersStatistics/RETRY_FETCH';
